<template>
  <fragment>
    <app-header :title="'Integrations'" />

    <c-horizontal-nav>
      <c-horizontal-nav-link :to="{ name: 'settings.integrations.single' }" exact>
        Settings
      </c-horizontal-nav-link>
      <c-horizontal-nav-link :to="{ name: 'settings.integrations.single.screens' }">
        Screens
      </c-horizontal-nav-link>
    </c-horizontal-nav>
    <div class="layout-sidesheet row">
      <div class="col main-content pb-0">
        <router-view v-if="integration.id" />
      </div>
    </div>
  </fragment>
</template>
<script>
// import { handleServerValidation } from '@/utils'
import { helperComputed, helperMethods } from '@/vuex/modules/settings/integrations'

export default {
  props: {
    integrationId: {
      type: Number,
      required: true
    }
  },
  async created () {
    await this.getIntegration(this.integrationId)
  },
  computed: {
    ...helperComputed,
  },
  methods: {
    ...helperMethods
  }
}
</script>
